import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Product } from '../../shared/models/product';
import { DashboardAnalyticsResponse } from '../../shared/models/dashboard-analytics';
import { ApiHttpService } from './api-http.service';

@Injectable()
export class ProductService {
  constructor(private http: ApiHttpService) {}

  getTopCustomers() {
    const url = 'order/customers/top-customer-by-order-amount';
    return this.http.get(url);
  }

  getRecentSales() {
    const url = 'order/recent/completed';
    return this.http.get(url);
  }

  getDashboardAnalytics(dateFilter?: string, startDate?: string, endDate?: string) {
    let url = 'order/analytics/dashboard';
    const params: string[] = [];

    if (dateFilter && dateFilter !== 'all') {
      params.push(`dateFilter=${dateFilter}`);

      if (dateFilter === 'custom' && startDate && endDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
        params.push(`endDate=${encodeURIComponent(endDate)}`);
      }
    }

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    return this.http.get(url);
  }
}
